import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageBanner({ title, subtitle, breadcrumbs = [] }) {
  return (
    <section className="relative h-[260px] md:h-[300px] overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1697982947220-01b97bdec381?auto=format&fit=crop&w=1920&q=70"
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 page-banner-overlay" />
      <div className="relative max-w-7xl mx-auto px-4 h-full flex flex-col justify-center text-white">
        <h1 className="font-heading font-extrabold text-3xl md:text-4xl">{title}</h1>
        {subtitle && <p className="text-white/80 max-w-2xl mt-2 text-sm md:text-base">{subtitle}</p>}
        <nav className="flex items-center gap-2 mt-4 text-[12.5px] text-white/85">
          <Link to="/" className="hover:text-[#f4b223]">Home</Link>
          {breadcrumbs.map((b, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight size={14} className="text-white/60" />
              {b.to ? (
                <Link to={b.to} className="hover:text-[#f4b223]">{b.label}</Link>
              ) : (
                <span className="text-[#f4b223]">{b.label}</span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </section>
  );
}
